import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeadphones,
  faReceipt,
  faFileImport,
  faFileAlt,
  faClipboardList,
  faTrashAlt,
  faFileSignature,
  faChartBar,
  faRetweet,
  faCamera,
  faChevronDown,
  faChevronRight,
  faBars,
  faArrowRight,
  faFileInvoice,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import BankFileModal from "../Modal/BankFileModal";
import API_BASE_URL from "../utilities/ApiConfig";
import axios from "axios";

const SideMenu = () => {
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);
  const [isModificationOpen, setIsModificationOpen] = useState(false);
  const [isReportsOpen, setIsReportsOpen] = useState(false);
  const [isCompulsoryMarriageOpen, setIsCompulsoryMarriageOpen] =
    useState(false);
  const [isPeriodicOpen, setIsPeriodicOpen] = useState(false);
  const [isShyahOpen, setIsShyahOpen] = useState(false);
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);
  const [isScanningOpen, setIsScanningOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isBankFileModalOpen, setIsBankFileModalOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  const toggleRegistrationMenu = () => {
    setIsRegistrationOpen(!isRegistrationOpen);
  };

  const toggleScanningMenu = () => {
    setIsScanningOpen(!isScanningOpen);
  };

  const toggleEditMenu = () => {
    setIsEditOpen(!isEditOpen);
  };

  const toggleReportsMenu = () => {
    setIsReportsOpen(!isReportsOpen);
  };
  const toggleModificationMenu = () => {
    setIsModificationOpen(!isModificationOpen);
  };

  const toggleCompulsoryMarriageMenu = () => {
    setIsCompulsoryMarriageOpen(!isCompulsoryMarriageOpen);
  };
  const togglePeriodicMenu = () => {
    setIsPeriodicOpen(!isPeriodicOpen);
  };
  const toggleShyahMenu = () => {
    setIsShyahOpen(!isShyahOpen);
  };
  const toggleRegisterMenu = () => {
    setIsRegisterOpen(!isRegisterOpen);
  };

  const toggleSidebar = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleBankFileModal = () => {
    setIsBankFileModalOpen(true);
  };

  // const handleBankFileModal = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${API_BASE_URL}/Registration/getDeedNames?mode=BANKFILE`
  //     );
  //     console.log("Deed Names Data:", response.data); // Handle response data as needed
  //     setIsBankFileModalOpen(true);
  //   } catch (error) {
  //     console.error("Error fetching deed names:", error);
  //   }
  // };

  const handleResize = () => {
    setIsMobileView(window.innerWidth <= 768);
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <div
        className={`md:block ${isMenuOpen ? "block" : "block"} min-h-full`}
        style={{
          backgroundColor: "#4F9CF9",
          color: "white",
          width: isMobileView ? "60px" : "230px",
          padding: "0px",
        }}
      >
        <Link
          to="/Dashboard"
          style={{ marginBottom: "30px", padding: "10px" }}
          className="mx-2"
        >
          {!isMobileView && (
            <>
              <h2 style={{ color: "white" }} className="text-2xl font-bold">
                CRS
              </h2>
              <p style={{ color: "white" }}>Core Registration System</p>
            </>
          )}
        </Link>

        {!isMobileView && (
          <h3
            style={{ color: "white" }}
            className="text-lg font-bold mb-1 border-b px-10"
          >
            MENU
          </h3>
        )}
        <ul style={{ listStyle: "none", padding: 0 }}>
          {/* <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
            <Link
              to="/ErrorPage"
              style={{ color: "white", textDecoration: "none" }}
            >
              <FontAwesomeIcon icon={faHeadphones} />
              {!isMobileView && " Enquiry Counter"}
            </Link>
          </li> */}
          <li className="mb-1 border-b p-2">
            <div
              style={{ cursor: "pointer", color: "white" }}
              onClick={toggleModificationMenu}
              className="mb-1"
            >
              <FontAwesomeIcon icon={faClipboardList} />
              {!isMobileView && (
                <>
                  {" Receipt Counter"}
                  <FontAwesomeIcon
                    icon={isModificationOpen ? faChevronDown : faChevronRight}
                    style={{ marginLeft: "10px", color: "white" }}
                  />
                </>
              )}
            </div>
            {isModificationOpen && !isMobileView && (
              <ul
                style={{
                  listStyle: "none",
                  paddingLeft: "20px",
                  marginTop: "8px",
                }}
              >
                <li
                  className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b"
                  style={{ position: "relative", cursor: "pointer" }}
                  onClick={toggleCompulsoryMarriageMenu}
                >
                  New Reciept
                  <FontAwesomeIcon
                    icon={
                      isCompulsoryMarriageOpen ? faChevronRight : faChevronDown
                    }
                    style={{ marginLeft: "10px", color: "white" }}
                  />
                  {isCompulsoryMarriageOpen && (
                    <ul
                      style={{
                        listStyle: "none",
                        paddingLeft: "10px",
                        marginTop: "8px",
                        position: "absolute",
                        left: "204px", // position it to the right
                        top: "0",
                        backgroundColor: "#3B79C3",
                        padding: "10px",
                        width: "160px",
                        borderRadius: "5px",
                        zIndex: "999",
                      }}
                    >
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/SearchReceipt"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Search
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/InspectionReceipt"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Inspection
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/CopyReceipt"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Copy
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/Commision"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Commission
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/NewReceipt"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Attendance
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/DeficiateReceipt"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Deficiate
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/Other"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Other
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li className="mb-1 mt-2 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/PrintReceiptReport"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Print Receipt
                  </Link>
                </li>

                <li
                  className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b"
                  style={{ position: "relative", cursor: "pointer" }}
                  onClick={toggleShyahMenu}
                >
                  Shyah
                  <FontAwesomeIcon
                    icon={isShyahOpen ? faChevronRight : faChevronDown}
                    style={{ marginLeft: "10px", color: "white" }}
                  />
                  {isShyahOpen && (
                    <ul
                      style={{
                        listStyle: "none",
                        paddingLeft: "10px",
                        marginTop: "8px",
                        position: "absolute",
                        left: "204px", // position it to the right
                        top: "0",
                        backgroundColor: "#3B79C3",
                        padding: "10px",
                        width: "160px",
                        borderRadius: "5px",
                        zIndex: "999",
                      }}
                    >
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/ShyahReport"
                          state={{ reportType: "Main" }}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Main Shyah
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/ShyahReport"
                          state={{ reportType: "Inspection" }}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Inspection Shyah
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/ShyahReport"
                          state={{ reportType: "Copy" }}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Copy Shyah
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/ShyahReport"
                          state={{ reportType: "Search" }}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Search Shyah
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/Challan"
                    state={{ reportType: "Main Challan" }}
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Main Challan
                  </Link>
                </li>

                <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/Statement2"
                    state={{ reportType: "Statement 1" }}
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Statement 1
                  </Link>
                </li>

                <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/Statement2"
                    state={{ reportType: "Statement 2" }}
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Statement 2
                  </Link>
                </li>
                <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/ModifyPDEdetailsAfterSubmit"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    <FontAwesomeIcon icon={faFileImport} /> Statement 3
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li className="mb-1 border-b p-2">
            <div
              style={{ cursor: "pointer", color: "white" }}
              onClick={toggleRegistrationMenu}
              className="mb-1"
            >
              <FontAwesomeIcon icon={faFileAlt} />
              {!isMobileView && (
                <>
                  {" Registration"}
                  <FontAwesomeIcon
                    icon={isRegistrationOpen ? faChevronDown : faChevronRight}
                    style={{ marginLeft: "10px", color: "white" }}
                  />
                </>
              )}
            </div>
            {isRegistrationOpen && !isMobileView && (
              <ul>
                <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/ImportPde"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    <FontAwesomeIcon icon={faFileImport} /> Import PDE
                  </Link>
                </li>
                <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/RegistrationTokenList"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Photo, Thumb, Sign
                  </Link>
                </li>
                <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/VirtualRegistrationTokenList"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Vitual Photo
                  </Link>
                </li>
                <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <button
                    onClick={handleBankFileModal}
                    className="text-white w-full text-left"
                  >
                    Bank File Land
                  </button>
                </li>
                {isBankFileModalOpen && (
                  <BankFileModal
                    onClose={() => setIsBankFileModalOpen(false)}
                  />
                )}
                <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/EndorsementReport"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    <FontAwesomeIcon icon={faFileImport} /> Regularlize PDE
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
            <Link
              to="/ErrorPage"
              style={{ color: "white", textDecoration: "none" }}
            >
              <FontAwesomeIcon icon={faRetweet} />
              {!isMobileView && " Resume Registration"}
            </Link>
          </li>

          <li className="mb-1 border-b p-2">
            <div
              style={{ cursor: "pointer", color: "white" }}
              onClick={toggleScanningMenu}
            >
              <FontAwesomeIcon icon={faCamera} />
              {!isMobileView && (
                <>
                  {" Scanning"}
                  <FontAwesomeIcon
                    icon={isScanningOpen ? faChevronDown : faChevronRight}
                    style={{ marginLeft: "10px", color: "white" }}
                  />
                </>
              )}
            </div>
            {isScanningOpen && !isMobileView && (
              <ul>
                <li className="mb-1 mt-2 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                  <Link
                    to="/Scan"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Scan
                  </Link>
                </li>
                <li className="mb-1 my-2 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                  <Link
                    to="/PrintDoc"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    View/Print Doc
                  </Link>
                </li>
                <li className="mb-1 my-2 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                  <Link
                    to="/ListOfScanDocumentsDatewise"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    List Scanned Doc. Datewise
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li className="mb-1 border-b p-2">
            <div
              style={{ cursor: "pointer", color: "white" }}
              onClick={toggleEditMenu}
            >
              <FontAwesomeIcon icon={faCamera} />
              {!isMobileView && (
                <>
                  {" Modification"}
                  <FontAwesomeIcon
                    icon={isEditOpen ? faChevronDown : faChevronRight}
                    style={{ marginLeft: "10px", color: "white" }}
                  />
                </>
              )}
            </div>
            {isEditOpen && !isMobileView && (
              <ul>
                <li className="mb-1 mt-2 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                  <Link
                    to="/ModifyReciept"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Modify Reciept
                  </Link>
                </li>
                <li className="mb-1 my-2 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                  <Link
                    to="/Dashboard"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Modify
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li className="mb-1 border-b p-2">
            <div
              style={{ cursor: "pointer", color: "white" }}
              onClick={toggleReportsMenu}
              className="mb-1"
            >
              <FontAwesomeIcon icon={faClipboardList} />
              {!isMobileView && (
                <>
                  {" Reports"}
                  <FontAwesomeIcon
                    icon={isReportsOpen ? faChevronDown : faChevronRight}
                    style={{ marginLeft: "10px", color: "white" }}
                  />
                </>
              )}
            </div>
            {isReportsOpen && !isMobileView && (
              <ul
                style={{
                  listStyle: "none",
                  paddingLeft: "20px",
                  marginTop: "0px",
                }}
              >
                <li className="mb-1 mt-2 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/EndorsementFinal"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Endorsement
                  </Link>
                </li>

                <li
                  className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b"
                  style={{ position: "relative", cursor: "pointer" }}
                  onClick={togglePeriodicMenu}
                >
                  Periodic Reports
                  <FontAwesomeIcon
                    icon={isPeriodicOpen ? faChevronRight : faChevronDown}
                    style={{ marginLeft: "10px", color: "white" }}
                  />
                  {isPeriodicOpen && (
                    <ul
                      style={{
                        listStyle: "none",
                        paddingLeft: "10px",
                        marginTop: "8px",
                        position: "absolute",
                        left: "204px", // position it to the right
                        top: "0",
                        backgroundColor: "#3B79C3",
                        padding: "10px",
                        width: "160px",
                        borderRadius: "5px",
                        zIndex: "999",
                      }}
                    >
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/IndexForm"
                          state={{ Index: "Index 1" }}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Index 1
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/IndexForm"
                          state={{ Index: "Index 2" }}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Index 2
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/IndexForm"
                          state={{ Index: "Index 3" }}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Index 3
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/IndexForm"
                          state={{ Index: "Index 4" }}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Index 4
                        </Link>
                      </li>

                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/VapsiRegister"
                          state={{ reportType: "Vapsi Register" }}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Vapsi Register
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/TehsilVapsiRegister"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Tehsil Vapsi Register
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/TransactionReports"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Transaction Reports
                        </Link>
                      </li>
                      <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-1 border-b">
                        <Link
                          to="/MonthlyReports"
                          state={{ reportType: "MonthlyReports" }}
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Monthly Reports
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/Statement2"
                    state={{ reportType: "Statement 2" }}
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Misc Report
                  </Link>
                </li>
                <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/HighestSaleDeeds"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    <FontAwesomeIcon icon={faFileImport} /> Highest Sale Deeds
                  </Link>
                </li>
                {/* <li className="mb-1 text-xs hover:bg-blue-600 hover:rounded p-2 border-b">
                  <Link
                    to="/ModifyPDEdetailsAfterSubmit"
                  
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    <FontAwesomeIcon icon={faFileImport} /> Statement 3
                  </Link>
                </li> */}
              </ul>
            )}
          </li>

          {/* <li className="mb-1 border-b text-base hover:bg-blue-600 hover:rounded p-2">
            <Link
              to="/ErrorPage"
              style={{ color: "white", textDecoration: "none" }}
            >
              <FontAwesomeIcon icon={faTrashAlt} />
              {!isMobileView && " Deletion"}
            </Link>
          </li> */}
          <li className="mb-1 border-b text-base hover:bg-blue-600 hover:rounded p-2">
            <Link
              to="/WebexForm"
              style={{ color: "white", textDecoration: "none" }}
            >
              <FontAwesomeIcon icon={faFileImport} />
              {!isMobileView && " WebexForm"}
            </Link>
          </li>
          <li className="mb-1 border-b text-base hover:bg-blue-600 hover:rounded p-2">
            <Link
              to="/eSign"
              style={{ color: "white", textDecoration: "none" }}
            >
              <FontAwesomeIcon icon={faFileImport} />
              {!isMobileView && " Esign"}
            </Link>
          </li>
          <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
            <Link
              to="/PowerRegularization"
              style={{ color: "white", textDecoration: "none" }}
            >
              <FontAwesomeIcon icon={faArrowRight} className="me-2" />
              {!isMobileView && "Regularization Request"}
            </Link>
          </li>
          <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
            <Link
              to="/PdeReview"
              style={{ color: "white", textDecoration: "none" }}
            >
              <FontAwesomeIcon icon={faFileInvoice} className="me-2" />
              {!isMobileView && "PDE Review"}
            </Link>
          </li>
          <li className="mb-1 border-b hover:bg-blue-600 hover:rounded p-2">
            <Link
              to="/DscRegularization"
              style={{ color: "white", textDecoration: "none" }}
            >
              <FontAwesomeIcon icon={faFileInvoice} className="me-2" />
              {!isMobileView && "Dsc Regularization"}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SideMenu;
